import { render, staticRenderFns } from "./room-rent-list.vue?vue&type=template&id=3c821ce6&scoped=true"
import script from "./room-rent-list.vue?vue&type=script&lang=js"
export * from "./room-rent-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c821ce6",
  null
  
)

export default component.exports